import React from "react";
import {
    Box,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Checkbox
} from "@mui/material";

import { FilterBar2 } from "../../../../components";

export default function ViewCalculatorPanel({ switchScreen, ...props }) {
    return (
        <Box>
            <FilterBar2 />
            <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table
                            sx={{
                                minWidth: 650,
                                '& .MuiTableCell-root': {
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                }
                            }}
                        >
                            <TableHead>
                                <TableRow
                                    sx={{
                                        backgroundColor: "#E6F5FE",
                                    }}
                                >
                                    <TableCell>Name</TableCell>
                                    <TableCell>language</TableCell>
                                    <TableCell>System Type</TableCell>
                                    <TableCell>Default</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <button
                                            style={{ backgroundColor: "transparent", border: 'none', cursor: 'pointer' }}
                                            onClick={() => switchScreen()}
                                        >
                                            Battery retrofit system
                                        </button>
                                    </TableCell>
                                    <TableCell>GERMAN (CH)</TableCell>
                                    <TableCell>Solar computer system battery retrofit</TableCell>
                                    <TableCell>
                                        <Checkbox />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <button
                                            style={{ backgroundColor: "transparent", border: 'none', cursor: 'pointer' }}
                                            onClick={() => switchScreen()}
                                        >
                                            solar system
                                        </button>
                                    </TableCell>
                                    <TableCell>GERMAN (CH)</TableCell>
                                    <TableCell>Solar computer system battery retrofit</TableCell>
                                    <TableCell>
                                        <Checkbox />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    )
}